// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9lcyi","textWrapper":"U2Q6l","title":"tTTb+"};